import { Content } from './select.styled';

export const Select = (props) => {
  const { value, onChange, ...rest } = props;
  const change = (event) => {
    onChange(event.target.value);
  };
  return <Content value={value} onChange={change} {...rest} />;
};
